export default "/images/my-referrals.png?655d5fb3dd25b4f1b5fdf2a1d9d0c432";